import * as types from './supplierTypeActionTypes';

export const getSupplierTypeRequestAction = (payload) => ({
  type: types.GET_SUPPLIERTYPE_REQUEST,
  payload,
});
export const getSupplierTypeDataAction = (payload) => ({
  type: types.GET_SUPPLIERTYPE_DATA,
  payload,
});
export const getSupplierTypeErrorAction = (payload) => ({
  type: types.GET_SUPPLIERTYPE_ERROR,
  payload,
});

export const createSupplierTypeRequestAction = (payload) => ({
  type: types.CREATE_SUPPLIERTYPE_REQUEST,
  payload,
});
export const createSupplierTypeDataAction = (payload) => ({
  type: types.CREATE_SUPPLIERTYPE_DATA,
  payload,
});
export const createSupplierTypeErrorAction = (payload) => ({
  type: types.CREATE_SUPPLIERTYPE_ERROR,
  payload,
});

export const updateSupplierTypeRequestAction = (payload) => ({
  type: types.UPDATE_SUPPLIERTYPE_REQUEST,
  payload,
});
export const updateSupplierTypeDataAction = (payload) => ({
  type: types.UPDATE_SUPPLIERTYPE_DATA,
  payload,
});
export const updateSupplierTypeErrorAction = (payload) => ({
  type: types.UPDATE_SUPPLIERTYPE_ERROR,
  payload,
});

export const deleteSupplierTypeRequestAction = (payload) => ({
  type: types.DELETE_SUPPLIERTYPE_REQUEST,
  payload,
});
export const deleteSupplierTypeDataAction = (payload) => ({
  type: types.DELETE_SUPPLIERTYPE_DATA,
  payload,
});
export const deleteSupplierTypeErrorAction = (payload) => ({
  type: types.DELETE_SUPPLIERTYPE_ERROR,
  payload,
});


